import Vue from "vue";
import VueResource from "vue-resource";

import router from "./routers";
import config from "./unit/config";
import store from "./store";
import utils from "./unit/index";
import filter from "./unit/filter";

Vue.prototype.$config = config;
Vue.prototype.$utils = utils;
/* vue resource */
Vue.use(VueResource);
Vue.http.interceptors.push(function (request, next) {

  request.url = request.url.indexOf('http://') > -1 ? request.url : config.api + request.url;
  // headers
  request.headers.set('appkey', 'owsite');
  //request.headers.set('version', config.version);
  // continue to next interceptor
  next(function (response) {
    let data = response.data;

    if (typeof data === 'object' && data.errno > 0) {
      $.alert(data.errmsg);

      response.status = 400;
      response.statusText = data.errmsg;

      return data;
    }
  });
});
//filter
Vue.filter('dateFormat', filter.dateFormat);
/* start */
new Vue({
  router,
  store
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js